module.exports = __webpack_public_path__ + "img/Group 1-4.05843a38.png";